var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item-avatar',{attrs:{"color":"#ccc"}},[(_vm.utente.url_fotoprofilo)?_c('v-img',{attrs:{"src":_vm.imgAvatar(_vm.utente)}}):_c('span',{staticClass:"text-h6",domProps:{"textContent":_vm._s(_vm.iniziali(_vm.utente))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }